import { type ComponentType } from 'react';
import { PwaDisabledIos } from '../PwaDisabledIos';
import { PwaDisabledAndroid } from '../PwaDisabledAndroid';
import { PwaInstallDesktop } from '../PwaInstallDesktop';
import { PwaInstallOldSafari } from '../PwaInstallOldSafari';
import { PwaInstallChrome } from '../PwaInstallChrome';
import { PwaInstallOther } from '../PwaInstallOther';
import { usePwaInstallControllerState } from './usePwaInstallControllerState';
import { PwaInstallUnavailableOnOldIos } from '../PwaInstallUnavailableOnOldIos';
import { PwaPage } from './enums';
import { PwaInstallSafariIos26 } from '../PwaInstallSafariIos26';
import { PwaInstallYandex } from '../PwaInstallYandex';
import { PwaInstallSafariIos27 } from '../PwaInstallSafariIos27';

const PAGE_MAP: Record<PwaPage, ComponentType> = {
  [PwaPage.DisabledIos]: PwaDisabledIos,
  [PwaPage.DisabledAndroid]: PwaDisabledAndroid,
  [PwaPage.InstallSafariIos26]: PwaInstallSafariIos26,
  [PwaPage.InstallSafariIos27]: PwaInstallSafariIos27,
  [PwaPage.InstallOldSafari]: PwaInstallOldSafari,
  [PwaPage.InstallUnavailableOnOldIos]: PwaInstallUnavailableOnOldIos,
  [PwaPage.InstallChrome]: PwaInstallChrome,
  [PwaPage.InstallYandex]: PwaInstallYandex,
  [PwaPage.InstallOther]: PwaInstallOther,
  [PwaPage.InstallDesktop]: PwaInstallDesktop,
};

export function PwaInstallController() {
  const pageKey = usePwaInstallControllerState();

  const Page = PAGE_MAP[pageKey];

  return <Page />;
}
